import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'productslimit' })
export class ProductsLimitPipe implements PipeTransform {

    public transform(items: any[], filter: number): any {
        if (!items) return;
        return items.slice(0, filter);
    }
}
